import { createContext, useContext, type ReactNode } from 'react';
import { useGameSession } from '@/modules/game-session/use-game-session';
import type { Locale, Translations } from '@/i18n';

export type GameSessionContextValue = ReturnType<typeof useGameSession>;

const GameSessionContext = createContext<GameSessionContextValue | null>(null);

export function GameSessionProvider({
  locale,
  translations,
  children,
}: {
  locale: Locale;
  translations: Translations;
  children: ReactNode;
}) {
  const value = useGameSession({ locale, translations });
  return <GameSessionContext.Provider value={value}>{children}</GameSessionContext.Provider>;
}

export function useGameSessionContext(): GameSessionContextValue {
  const ctx = useContext(GameSessionContext);
  if (!ctx) {
    throw new Error('useGameSessionContext must be used within GameSessionProvider');
  }
  return ctx;
}
